import type { AuthContextProps } from 'react-oidc-context';
import type { NavigateFunction } from 'react-router-dom';

export const LOGOUT_IN_PROGRESS_KEY = 'sinalinvest.logout.in.progress';

const COGNITO_HOSTED_UI_DOMAIN =
  process.env.REACT_APP_COGNITO_HOSTED_UI_DOMAIN ?? 'https://auth.sinalinvest.com';
const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID ?? '142lurdgkn78inlb9qup85bsa0';
const COGNITO_LOGOUT_REDIRECT_URI =
  process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI ?? window.location.origin;

const buildHostedUiLogoutUrl = (): string | null => {
  if (!COGNITO_HOSTED_UI_DOMAIN || !COGNITO_CLIENT_ID) {
    return null;
  }

  const normalizedDomain = COGNITO_HOSTED_UI_DOMAIN.replace(/\/+$/, '');
  const logoutUri = encodeURIComponent(COGNITO_LOGOUT_REDIRECT_URI);
  return `${normalizedDomain}/logout?client_id=${encodeURIComponent(COGNITO_CLIENT_ID)}&logout_uri=${logoutUri}`;
};

export const performLogout = async (auth: AuthContextProps, navigate?: NavigateFunction): Promise<void> => {
  window.localStorage.setItem(LOGOUT_IN_PROGRESS_KEY, '1');

  try {
    auth.stopSilentRenew();
  } catch (error) {
    console.error('Erro ao desativar renovação silenciosa no logout:', error);
  }

  try {
    // Garante logout local mesmo que o redirect do provedor falhe.
    await auth.removeUser();
  } catch (error) {
    console.error('Erro ao limpar usuário local no logout:', error);
  }

  try {
    await auth.clearStaleState();
  } catch (error) {
    console.error('Erro ao limpar estado stale no logout:', error);
  }

  const hostedUiLogoutUrl = buildHostedUiLogoutUrl();
  if (hostedUiLogoutUrl) {
    window.location.assign(hostedUiLogoutUrl);
    return;
  }

  if (navigate) {
    navigate('/', { replace: true });
  } else {
    window.location.assign('/');
  }
};
